import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import DocsSidebar from "../components/DocsSidebar";
import DocsHeader from "../components/DocsHeader";

const sections = [
    {
        title: "Getting Started",
        items: [
            {
                title: "Introduction",
                path: "/docs/atp",
            },
        ],
    },
];

const links = [
    {
        title: "Home",
        path: "/docs/atp",
    },
    // {
    //     title: "Introduction",
    //     path: "/docs/atp/introduction",
    // },
];

function ATPDocs() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className="min-h-screen bg-gray-50 ">
            <DocsHeader
                onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}
                links={links}
            />
            <div className="flex">
                <DocsSidebar
                    isOpen={isSidebarOpen}
                    onClose={() => setIsSidebarOpen(false)}
                    sections={sections}
                />
                <main className="flex-1 px-4 sm:px-6 lg:px-8 overflow-x-hidden">
                    <div className="max-w-[90rem] mx-auto">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}

export default ATPDocs;
